import styled from 'styled-components';

export default function PaymentOptionCustomInput(props) {
  const { value, setValue, placeholder, width, disabled, textAlign, index } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    const inputValue = e.target.value;
    if (inputValue === '' || /^[0-9][0-9,]*$/.test(inputValue)) {
      setValue(inputValue, index);
    }
  }

  function handleFocus(e) {
    if (value === '0') setValue('', index);
  }

  function handleBlur(e) {
  }

  return (
    <Input
      type='text'
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: ${props => props.width}px;
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid #B2B2B2;
	border-radius: 5px;
	color: #000000;

  text-align: ${props => props.textAlign};

	::placeholder {
		color: ${props => props.disabled ? `#FFFFFF` : `#CBCBCB`};
	}
  
  &:disabled {
    background-color: #CBCBCB;
    color: #FFFFFF; 
    cursor: not-allowed;
  }
	
  transition: all 0.3s ease-in-out;
`;